import { schema } from "normalizr";
import { Statement as StatementRecord } from "records/payments";

export const Statement = new schema.Entity(
    "statement",
    {},
    {
        idAttribute: "id",
    }
);

(Statement as any).record = StatementRecord;
